import { MARKER_CONFIG } from "./drawToolsConfig";

export const createCustomMarker = () => {
  const img = document.createElement("img");
  img.src = MARKER_CONFIG.imagePath;
  img.style.width = MARKER_CONFIG.width;
  img.style.height = MARKER_CONFIG.height;
  return img;
};

export const deleteOldFeatures = (
  drawRef,
  geometryType,
  currentFeatureId,
  markersRef = null,
) => {
  if (!drawRef.current) return;

  const existingFeatures = drawRef.current
    .getAll()
    .features.filter((f) => f.geometry.type === geometryType);

  existingFeatures.forEach((feature) => {
    if (feature.id !== currentFeatureId) {
      drawRef.current.delete(feature.id);

      // Remove associated marker for points
      if (geometryType === "Point" && markersRef) {
        const marker = markersRef.current.get(feature.id);
        if (marker) {
          marker.remove();
          markersRef.current.delete(feature.id);
        }
      }
    }
  });
};
export const showDeleteModal = (onConfirm, onCancel) => {
  const modal = document.createElement("div");
  modal.innerHTML = `
    <div class="modal-overlay">
      <div class="modal-content">
        <p>Voulez-vous supprimer cette forme ?</p>
        <div id="modal-btns">
          <button id="confirm-button">Confirmer</button>
          <button id="reset-button">Annuler</button>
        </div>
      </div>
    </div>
  `;
  document.body.appendChild(modal);

  const cleanup = () => document.body.removeChild(modal);

  document.getElementById("confirm-button").addEventListener("click", () => {
    onConfirm();
    cleanup();
  });

  document.getElementById("reset-button").addEventListener("click", () => {
    if (onCancel) onCancel();
    cleanup();
  });
};
export const showEditModal = (onConfirm, onReset) => {
  const modal = document.createElement("div");
  modal.innerHTML = `
    <div class="modal-overlay">
      <div class="modal-content">
        <p>Voulez-vous enregistrer les modifications ?</p>
        <div id="modal-btns">
          <button id="confirm-button">Confirmer</button>
          <button id="reset-button">Annuler</button>
        </div>
      </div>
    </div>
  `;
  document.body.appendChild(modal);

  const cleanup = () => document.body.removeChild(modal);

  document.getElementById("confirm-button").addEventListener("click", () => {
    onConfirm();
    cleanup();
  });

  document.getElementById("reset-button").addEventListener("click", () => {
    onReset();
    cleanup();
  });
};

export const resetFeatureGeometry = (drawRef, originalGeometry) => {
  if (!drawRef.current || !originalGeometry) return;

  const featureId = originalGeometry.id;
  drawRef.current.delete(featureId);
  drawRef.current.add(originalGeometry);
  drawRef.current.changeMode("simple_select");
};

export const getFeaturesByType = (drawRef, geometryType) => {
  if (!drawRef.current) return [];

  const data = drawRef.current.getAll();
  return data.features.filter(
    (feature) => feature.geometry.type === geometryType,
  );
};
